










import { Component, Vue,Prop,Watch } from 'vue-property-decorator'
import { sumptionRatio } from '@/api/home'
// import { getColors } from '@/utils'
import NoData from '@/components/NoData'

const echarts = require('echarts')
@Component({
  name: 'ConsumptionStructure',
  components:{NoData}
})
export default class ConsumptionStructure extends Vue {
  @Prop({default:''}) code!:string
  private data : any = []
  sumptionRatioData(e:any){
    sumptionRatio({
      regionCode:e,
      unitType:1
    }).then((res :any)=>{
      if(res.status == 0){
        this.data = []
        const colors = [{
           color: '#4680f5',
           borderColor: '#00a1ff',
           borderWidth: 3
        },{
           color: '#54b8b4',
           borderColor: '#2ad9d2',
           borderWidth: 3
        },{
           color: '#c17bfd',
           borderColor: '#e408ff',
           borderWidth: 3
        }]

        // let i = 0
        res.data.forEach((item:any) =>{
          // if(colors.length -1 == i){
          //   i = 0
          // }
          this.data.push({
            name:item.energyName,
            value:item.dataValue,
            ratio:item.ratio,
            // itemStyle: colors[i]
          })
          // i++
        })
        this.init()
      }
    //   if(!res.data){
    //     this.data = null
    //   }
    }).catch(err =>{
    })
  }

   private init() {
      const main = document.getElementById('ConsumptionStructure')
      // 基于准备好的dom，初始化echarts实例
      const myChart:any = echarts.init(main as HTMLDivElement)
      // 指定图表的配置项和数据
    const option = {
    // color: getColors(),
    grid: {
        left: '2%',
        top: '1%',
        bottom: 10,
        right: '1%',
        containLabel: true
    },
    tooltip: {
        trigger: 'item',
        textStyle: {
            fontSize: 14
        },
        formatter: '{b} : {c} ({d}%)'
    },
    legend: {
        x: 'center',
        bottom: '0%',
        textStyle: {
            color: '#ffffff',
            fontSize: 12
        },
        itemWidth: 10,
        itemHeight: 6,
        // data: 
    },
    calculable: true,
    series: [
        {
        type: 'pie',
        radius: ['6%', '8%'],
        center: ['50%', '40%'],
        hoverAnimation: false,
        labelLine: {
            normal: {
                show: false 
            },
            emphasis: {
                show: false
            }
        },
        data: [{
            name: '',
            value: 0,
            itemStyle: {
                normal: {
                    color: '#68c5ff'
                }
            }
        }]
    }, 
    {
        type: 'pie',
        radius: ['49.5%', '50%'],
        center: ['50%', '40%'],
        hoverAnimation: false,
        labelLine: {
            textStyle: {
                  color: '#fff'  // 改变标示文字的颜色
            },
            normal: {
                show: false,
            },
            emphasis: {
                show: false
            }
        },
        name: '',
        data: [{
            name: '',
            value: 0,
            itemStyle: {
                normal: {
                    color: '#0674bf'
                }
            }
        }]
    }, {
        stack: '',
        type: 'pie',
        radius: ['20%', '40%'],
        center: ['50%', '40%'],
        roseType: 'area',
        zlevel: 10,
        label: {
            textStyle: {
                  color: '#fff'  // 改变标示文字的颜色
            },
            normal: {
                formatter(e:any){
                  return (Number(e.data.ratio) * 100).toFixed(2) + '%'
                },
                borderWidth: 0,
                borderRadius: 4,
                padding: [0, -50],
                height: 40,
                fontSize: 12,
                align: 'center',
                textStyle: {
                  color: '#fff'  // 改变标示文字的颜色
            },
                rich: {
                    b: {
                        fontSize: 13,
                        lineHeight: 5,
                        color: '#ffffff'
                    }
                }
            }
        },
        labelLine: {
          textStyle: {
                  color: '#fff'  // 改变标示文字的颜色
            },
            normal: {
                show: true,
                length: 20,
                length2: 55
            },
            emphasis: {
                show: false
            }
        },
        data: this.data
    }, ]
}
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
  }
    updatafun(){
        setTimeout(() => {
        this.init()
        }, 0)
    }
  @Watch('code')
    onChangeData(e:any) {
        this.sumptionRatioData(e)
    }
    created() {
        this.sumptionRatioData(this.code)
    }
}
